import { c as _c } from "react/compiler-runtime";
import type { CSSProperties } from "react";
import { computeRankChange } from "@/entities/search-ranking/model/computeRankChange";
import { RankChange, RankNumber } from "@/widgets/search-ranking/ui/atoms";
interface RankingHospitalCardLeadingProps {
  rank: number;
  previousRank?: number | null;
}
const RankingHospitalCardLeading = t0 => {
  const $ = _c(13);
  const {
    rank,
    previousRank
  } = t0;
  let t1;
  if ($[0] !== previousRank || $[1] !== rank) {
    t1 = computeRankChange(rank, previousRank);
    $[0] = previousRank;
    $[1] = rank;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const rankChange = t1;
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      "--width": 28,
      "--height": 48
    };
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== rank) {
    t3 = <div className="dynamic-size flex flex-col items-center justify-center gap-1.5" style={t2 as CSSProperties}><RankNumber rank={rank} /></div>;
    $[4] = rank;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      "--width": 26,
      "--height": 18
    };
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== rankChange.type || $[8] !== rankChange.value) {
    t5 = <div className="dynamic-size flex items-center justify-center" style={t4 as CSSProperties}><RankChange type={rankChange.type} value={rankChange.value} /></div>;
    $[7] = rankChange.type;
    $[8] = rankChange.value;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t3 || $[11] !== t5) {
    t6 = <div className="flex shrink-0 flex-col items-center justify-center self-stretch">{t3}{t5}</div>;
    $[10] = t3;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  return t6;
};
export default RankingHospitalCardLeading;